import styled from 'styled-components';

export const VideoTourWrapper = styled.div`
  display: flex;
  font-size: 16px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 426px) {
    font-size: 14px;
  }
`;

export const Title = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 400;
  font-size: 1.5em;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.830769px;
  text-transform: uppercase;
  color: #38424D;
  margin-bottom: 16px;
  text-align: center;
`;

export const Strong = styled.span`
  font-family: 'Proxima Nova';
  font-weight: 700;
`;

export const Video = styled.div`
  width: 100%;
  height: 342px;
  @media (max-width: 768px) {
    height: auto;
  }
`

export const Footer = styled.div`
  display: flex;
  width: 100%;
  max-width: 503px;
  margin-top: 16px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 426px) {
    flex-direction: column;
  }
`;

export const Info = styled.span`
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: 500;
  font-size: 0.90625em;
  line-height: 25px;
  color: #607184;
  width: 250px;  
  @media (max-width: 426px) {
    line-height: 20px;
    width:  300px;
  }
`;

export const ButtonWrapper = styled.div`
  height: 48px;
  width: 228px;
  min-width: 150px;
  /* margin-left: 20px; */
  @media (max-width: 426px) {
    margin-top: 16px;
  }
`;